import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { FacultyTypeResponse } from "../../models/dtos";

export const facultyTypesApi = createApi({
  reducerPath: 'facultyTypesApi',
  baseQuery: baseAuthQuery('FacultyTypes'),
  tagTypes: ['FacultyType'],
  endpoints: (builder) => ({
    getFacultyTypes: builder.query<ApiResponse<FacultyTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['FacultyType'],
    }),
    getFacultyTypeById: builder.query<ApiResponse<FacultyTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['FacultyType'],
    }),
    updateFacultyType: builder.mutation<ApiResponse<FacultyTypeResponse>, Partial<FacultyTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['FacultyType'],
    }),
    deleteFacultyType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['FacultyType'],
    }),
  }),
});